import { LoadingOverlay } from "@mantine/core";

export default function PSLoader() {
  return <LoadingOverlay color="#FF5a60" variant="bars" />
}